import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { Intervention, InterventionReferential, PostIntervention, PutIntervention } from 'src/app/interfaces/api/intervention';
import { QueryParams } from 'src/app/interfaces/shared/query';
import { ApiService } from '../../core/api.service';
import { RequestService } from '../../core/request.service';
import { SyncStateService } from '../../core/sync-state.service';
import { WebSocketService } from '../../core/web-socket.service';

export interface InterventionSearchResult {
  results: Intervention[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class InterventionService {
  private readonly apiService: ApiService = inject(ApiService);
  private readonly request: RequestService = inject(RequestService);
  private readonly syncStateService: SyncStateService = inject(SyncStateService);
  private readonly socket: WebSocketService = inject(WebSocketService);

  collection = 'Intervention';
  collectionPath = 'interventions';

  //---GET---//
  searchAndCountInterventions(query: QueryParams = {}): Observable<InterventionSearchResult> {
    return this.apiService.getCollection(this.collectionPath, 'searchAndCount', query);
  }

  searchAndCountAllInterventions(query: QueryParams = {}): Observable<InterventionSearchResult> {
    return this.apiService.getCollection(this.collectionPath, 'all/searchAndCount', query);
  }

  primeSyncState(): void {
    this.syncStateService.getDbSyncStateFromServer(this.request.getCurrentDb())
      .pipe(catchError(() => EMPTY))
      .subscribe();
  }

  getIntervention(id: string): Observable<Intervention> {
    return this.apiService.getCollectionItem(this.collectionPath, '', id);
  }

  getInterventionReferential(): Observable<InterventionReferential> {
    return this.apiService.getCollection('intervention-referential', '', {});
  }

  getAllIntervention(id: string): Observable<Intervention> {
    return this.apiService.getCollectionItem(this.collectionPath, 'all', id);
  }

  watchChanges(): Observable<unknown> {
    return this.socket.getUpdate(this.collection);
  }

  //---POST---//

  addIntervention(intervention: PostIntervention): Observable<Intervention> {
    return this.request.postItem(this.collection, this.collectionPath, intervention);
  }

  //---PUT---//

  updateIntervention(intervention: PutIntervention): Observable<Intervention> {
    return this.request.setProjectData(this.collection, this.collectionPath, intervention);
  }

  updateAllIntervention(intervention: PutIntervention): Observable<Intervention> {
    return this.apiService.updateCollection(this.collectionPath, `all/${intervention.id}`, intervention);
  }

  //---DELETE---//

  removeIntervention(id: string): Observable<any> {
    return this.request.deleteItem(this.collection, this.collectionPath, id);
  }

  removeAllIntervention(id: string): Observable<any> {
    return this.apiService.deleteCollectionItem(`${this.collectionPath}/all`, id);
  }
}